<main
  class="order-tracker-component"
  [class.rtl]="rtlMode"
  [class.widescreen]="(biggerThan$ | async)?.sm"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll" cdk-scrollable>
    <div class="content">
      <app-track-order
        *ngIf="order$ | async"
        [mode]="isPublicDelivery ? 'public_buyer' : 'buyer'"
        [order]="order$ | async"
        [loading]="!(order$ | async)"></app-track-order>
      <!-- Search Delivery Form -->
      <section
        *ngIf="!(order$ | async) && !fetchingDelivery"
        class="search"
        [class.compact]="(lessThan$ | async)?.lg === true"
        [class.column]="(lessThan$ | async)?.md === true"
        [class.phone]="(lessThan$ | async)?.mobileXL === true"
        [cdkTrapFocus]="true"
        cdkTrapFocusAutoCapture>
        <div class="flex flex-col align-center">
          <div class="header">
            <h1 class="title">{{ t('link_zendesk_orders') }}</h1>
            <h4>{{ t('label_order_id') }}</h4>
          </div>
          <span class="fixed-space-16" aria-hidden="true"></span>

          <form
            *ngIf="!(fetchingOrder$ | async)"
            #myform="ngForm"
            (ngSubmit)="onSubmitOrderId(myform)"
            class="form flex flex-col">
            <input
              type="text"
              name="delivery"
              class="field form-field"
              [placeholder]="t('hint_order_id')"
              ngModel />
            <span class="fixed-space-16" aria-hidden="true"></span>
            <button class="popsy-button-primary cta" type="submit">
              <span>{{ t('hint_search') }}</span>
            </button>
          </form>
          <span class="fixed-space-64" aria-hidden="true"></span>
        </div>
      </section>

      <app-footer
        class="footer"
        [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
    </div>
  </div>
</main>
